import script from "./MyPropertyDatailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPropertyDatailComponent.vue?vue&type=script&setup=true&lang=js"

import "./MyPropertyDatailComponent.vue?vue&type=style&index=0&id=1c22bbe3&lang=css"

const __exports__ = script;

export default __exports__